var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.164 16.6079C20.3931 15.3874 19.2369 14.456 17.856 13.9742C16.7641 14.9377 15.3189 15.548 13.745 15.548C12.1712 15.548 10.726 14.97 9.63412 13.9742C7.32172 14.7771 5.58748 16.8646 5.36261 19.4339L5.00932 23.1918C4.91298 24.123 5.55527 24.9582 6.45451 25.1509L11.561 26.1787C13.0062 26.4677 14.5157 26.4677 15.9609 26.1787L17.1492 25.9218C16.2499 24.9262 15.704 23.6094 15.704 22.1641C15.6719 19.1451 18.1449 16.6401 21.164 16.6078L21.164 16.6079Z",
    fill: "#38A169"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.497 13.6211C12.1716 13.9743 12.9422 14.167 13.7451 14.167C14.548 14.167 15.3189 13.9743 15.9932 13.6211C17.5348 12.8181 18.5626 11.2123 18.5626 9.34955C18.5626 6.68387 16.4108 4.5 13.7131 4.5C11.0474 4.5 8.86353 6.65181 8.86353 9.34955C8.9276 11.2123 9.9552 12.8181 11.497 13.6211H11.497Z",
    fill: "#38A169"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8063 17.9247C21.6136 17.8926 21.453 17.8926 21.2604 17.8926C18.8837 17.8926 16.9568 19.8197 16.9568 22.1962C16.9568 23.6094 17.6314 24.8619 18.659 25.6328C19.3655 26.1787 20.2969 26.5 21.2604 26.5C23.637 26.5 25.5639 24.5729 25.5639 22.1964C25.5639 20.0122 23.926 18.1816 21.8063 17.9247L21.8063 17.9247ZM23.8297 21.4253L21.0356 24.2194C20.843 24.4121 20.4897 24.4121 20.297 24.2194L20.1041 24.0267L18.7873 22.7099C18.5946 22.5172 18.5946 22.164 18.7873 21.9713L18.9799 21.7786C19.1726 21.586 19.5259 21.586 19.7186 21.7786L20.6821 22.7099L22.8982 20.4938C23.1231 20.3011 23.4442 20.3011 23.6368 20.4938L23.8295 20.6864C24.0224 20.8793 24.0224 21.2006 23.8297 21.4253L23.8297 21.4253Z",
    fill: "#38A169"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresent);
export default __webpack_public_path__ + "static/media/Present.477f9784074558cb4b54ff05aa5f99f5.svg";
export { ForwardRef as ReactComponent };